import { render, staticRenderFns } from "./tabGamePlay.vue?vue&type=template&id=e056adf2&scoped=true"
import script from "./tabGamePlay.vue?vue&type=script&lang=js"
export * from "./tabGamePlay.vue?vue&type=script&lang=js"
import style0 from "./tabGamePlay.vue?vue&type=style&index=0&id=e056adf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e056adf2",
  null
  
)

export default component.exports